export const appConfig = {
    colors: {
        foregroundDefault: '#fffefa',
        backgroundColor: '#05090c',
        goldColor: '#fdc53a',
    }
}